export default function Portfolio() {
  return (
    <section id="portfolio" className="py-24 bg-slate-50">
      <div className="container mx-auto px-6">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-800 mb-6">
            Portfólio de Investimentos
          </h2>
          <p className="text-lg text-slate-600 leading-relaxed">
            Projetos de sucesso em diferentes setores da economia brasileira
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
          <div className="grid md:grid-cols-2 gap-0">
            <div className="relative h-[400px] md:h-auto">
              <img 
                src="https://readdy.ai/api/search-image?query=Modern%20customer%20loyalty%20program%20digital%20interface%20on%20smartphone%20screen%2C%20colorful%20rewards%20points%20system%20visualization%2C%20contemporary%20retail%20technology%20platform%20with%20clean%20design%2C%20Brazilian%20market%20consumer%20engagement%20app%2C%20professional%20fintech%20photography%20with%20vibrant%20teal%20and%20blue%20accents%2C%20sleek%20mobile%20application%20interface%2C%20customer%20relationship%20management%20technology&width=800&height=900&seq=netpoints-001&orientation=portrait"
                alt="Netpoints Fidelidade"
                className="absolute inset-0 w-full h-full object-cover object-top"
              />
            </div>

            <div className="p-12 flex flex-col justify-center">
              <div className="mb-6">
                <span className="inline-block px-4 py-2 bg-teal-600 text-white text-sm font-semibold rounded-full mb-4">
                  Case de Sucesso
                </span>
                <h3 className="text-4xl font-bold text-slate-800 mb-4">
                  NETPOINTS FIDELIDADE S.A.
                </h3>
              </div>

              <p className="text-slate-600 leading-relaxed mb-6">
                A NETPOINTS FIDELIDADE S.A. é uma sociedade idealizada pela Selem&Selem Participações e outros sócios empreendedores em 2011, resultado da avaliação que o mercado brasileiro de fidelidade no modelo de coalização junto ao mercado varejista necessitava de uma solução estruturada e capaz de realizar ações de CRM comportamental utilizando modelos estatísticos segmentados.
              </p>

              <div className="space-y-4 mb-8">
                <div className="flex items-start space-x-3">
                  <div className="w-8 h-8 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-calendar-line text-teal-600"></i>
                  </div>
                  <div>
                    <p className="text-slate-800 font-semibold">Fundação em 2011</p>
                    <p className="text-slate-600 text-sm">Constituída em março após detalhado trabalho de identificação dos principais players do mercado</p>
                  </div>
                </div>

                <div className="flex items-start space-x-3">
                  <div className="w-8 h-8 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-team-line text-teal-600"></i>
                  </div>
                  <div>
                    <p className="text-slate-800 font-semibold">+16 Milhões de Associados</p>
                    <p className="text-slate-600 text-sm">Alcançados nos primeiros 5 anos através de parcerias com renomados varejistas nacionais</p>
                  </div>
                </div>

                <div className="flex items-start space-x-3">
                  <div className="w-8 h-8 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-trophy-line text-teal-600"></i>
                  </div>
                  <div>
                    <p className="text-slate-800 font-semibold">Top 5 do Brasil</p>
                    <p className="text-slate-600 text-sm">Figurando entre os 5 maiores programas de fidelidade do Brasil</p>
                  </div>
                </div>
              </div>

              <div className="bg-slate-50 rounded-xl p-6">
                <h4 className="text-lg font-bold text-slate-800 mb-3">Participação da Selem&Selem</h4>
                <p className="text-slate-600 text-sm leading-relaxed">
                  Desde o desenho do modelo de negócios, plataforma tecnológica e modelo operacional pré e pós operacional, a Selem&Selem participou como sócio fundador, contribuindo com expertise estratégica e operacional.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 grid md:grid-cols-4 gap-6">
          <div className="bg-white rounded-xl p-6 text-center shadow-md">
            <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-gift-line text-3xl text-teal-600"></i>
            </div>
            <h4 className="text-lg font-bold text-slate-800 mb-2">Fidelidade</h4>
            <p className="text-slate-600 text-sm">Programas de recompensa e engajamento</p>
          </div>

          <div className="bg-white rounded-xl p-6 text-center shadow-md">
            <div className="w-16 h-16 bg-slate-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-star-line text-3xl text-slate-600"></i>
            </div>
            <h4 className="text-lg font-bold text-slate-800 mb-2">Incentivos</h4>
            <p className="text-slate-600 text-sm">Soluções de motivação e performance</p>
          </div>

          <div className="bg-white rounded-xl p-6 text-center shadow-md">
            <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-customer-service-line text-3xl text-teal-600"></i>
            </div>
            <h4 className="text-lg font-bold text-slate-800 mb-2">Serviços</h4>
            <p className="text-slate-600 text-sm">Consultoria e gestão estratégica</p>
          </div>

          <div className="bg-white rounded-xl p-6 text-center shadow-md">
            <div className="w-16 h-16 bg-slate-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-code-box-line text-3xl text-slate-600"></i>
            </div>
            <h4 className="text-lg font-bold text-slate-800 mb-2">Tecnologia</h4>
            <p className="text-slate-600 text-sm">Plataformas e soluções digitais</p>
          </div>
        </div>
      </div>
    </section>
  );
}
